import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of, throwError } from 'rxjs';
import { catchError, concatMap, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { ContractStatusEntity } from '../../../entities/mdqx/contract-status.entity';
import { ContractStatusActionTypes, GetContractStatusResponse } from '../../actions/mdqx/contract-status.actions';
import { HttpService } from '../../../services/http.service';
import { DaveActions } from '../../actions/actions';
import { getToken } from '../../selectors/base.selectors';
import { BaseActionTypes } from '../../actions/base.actions';
import { State } from '../../index';
import { environment } from '../../../../../environments/environment';

enum ErrorCodes {
    Get = 'ContractStatus Abrufen fehlgeschlagen',
}

@Injectable()
export class ContractStatusEffects {
    
    get$ = createEffect(() => this.actions$.pipe(
        ofType(ContractStatusActionTypes.GetContractStatusRequest),
        map(
            () => `
            {
                contractStatus {
                    ${ContractStatusEntity.GqlFields}
                }
            }`,
        ),
        withLatestFrom(this.store.select(getToken)),
        switchMap(([query, token]) =>
            this.api.graphQl({ query }, { token }, '', environment.mdqxGatewayApiUrl).pipe(
                map(res => res && res.contractStatus),
                concatMap(res =>
                    res
                        ? [
                              new GetContractStatusResponse(
                                  res.map(
                                      contractStatus =>
                                          new ContractStatusEntity(contractStatus),
                                  ),
                              ),
                          ]
                        : throwError('empty response'),
                ),
                catchError((err, caught) => of(BaseActionTypes.ErrorAction({
                    Payload: {
                        ToasterMessage: ErrorCodes.Get,
                        Err: err,
                        Caught: caught,
                    }
                }))),
            ),
        ),
    ));

    constructor(
        private actions$: Actions<DaveActions>,
        private api: HttpService,
        private store: Store<State>,
    ) {}
}
